<div class="main-wrapper">

    <div class="login-wrapper">

        <div class="header">
            <div class="header-logo"><img src="../../../assets//img/login_logo.png"></div>
            <div class="header-language-selectors">
                <div (click)="changeLang('es')"><img style="margin-right: 8px"
                        src="../../../assets/img/flags/es_black.png">
                </div>
                <div (click)="changeLang('cat')"><img style="margin-right: 8px"
                        src="../../../assets/img/flags/cat_black.png">
                </div>
                <div (click)="changeLang('en')"><img src="../../../assets/img/flags/en_black.png"></div>
            </div>
        </div>

        <div *ngIf="!showPasswordResetProgressSpinner && !error.show && !success" class="login-content">
            <p>{{ 'login.new_password_intro' | translate }}</p>
        </div>

        <div *ngIf="!showPasswordResetProgressSpinner && !error.show && !success" class="login-form"
            [formGroup]="resetPasswordForm">


            <mat-form-field appearance="outline">
                <input type="password" matInput placeholder="{{ 'login.new_password' | translate }}"
                    [formControlName]="'password'">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <input type="password" matInput placeholder="{{ 'login.repeat_password' | translate }}"
                    [formControlName]="'password_repeat'">
            </mat-form-field>

        </div>

        <div *ngIf="!showPasswordResetProgressSpinner && error.show" class="message">

            <p style="color: red; font-size: 16px;">{{ 'alerts.invalid_oobcode' | translate }}</p>

        </div>

        <div *ngIf="success" class="message">
            <p style="color: green; font-size: 16px;">{{ 'alerts.password_reset_success' | translate }}</p>
        </div>

        <div class="login-actions">
            <div *ngIf="!showPasswordResetProgressSpinner && !error.show && !success" class="login-button-wrapper">
                <button mat-flat-button class="login-button" (click)="resetPassword(resetPasswordForm)">{{
                    'buttons.reset_password' | translate }}</button>
            </div>
            <div class="action-button-wrapper">
                <button mat-flat-button class="action-button" routerLink="/login">
                    <mat-icon>keyboard_arrow_left</mat-icon> {{ 'buttons.return' | translate }}
                </button>
            </div>
        </div>

    </div>

</div>

<!-- <div class="login-wrapper" fxLayout="row" fxLayoutAlign="center center">
 
    <mat-card class="login-form">

        <mat-card-header>

            <ul fxLayout="row" fxLayoutGap="20px">
                <div style="width: 100%;">
                    <img class="login-logo" src="../../../assets/img/Logo - maknetic.png" />

                </div>

                <button mat-icon-button [matMenuTriggerFor]="langMenu">
                    <img id="idioma" src="../../../assets/img/flags/{{selectedLanguageFlag}}.svg">
                </button>
                <mat-menu #langMenu="matMenu">
                    <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('es')"
                        mat-menu-item><img id="idioma" src="../../../assets/img/flags/es.svg"> {{'langs.es' |
                        translate}}</button>
                    <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('cat')"
                        mat-menu-item><img id="idioma" src="../../../assets/img/flags/cat.svg"> {{'langs.cat' |
                        translate}}</button>
                    <button mat-menu-item fxLayoutAlign="left center" id="idioma" (click)="changeLang('en')"
                        mat-menu-item><img id="idioma" src="../../../assets/img/flags/en.svg"> {{'langs.en' |
                        translate}}</button>
                </mat-menu>

            </ul>

        </mat-card-header>


        <div *ngIf="showPasswordResetProgressSpinner" class="spinner-wrapper">
            <mat-spinner class="spinner-inner"></mat-spinner>
        </div>

        <div *ngIf="!showPasswordResetProgressSpinner && !error.show && !success">
            <p style="display: {{'es' | translate}};">Introduzca la nueva contraseña y haga click en el botón para
                confirmar el cambio.</p>
            <p style="display: {{'cat' | translate}};">Introduïu la nova contrasenya i feu clic al botó per confirmar el
                canvi.</p>
            <p style="display: {{'en' | translate}};">Enter the new password and click the button to confirm the change.
            </p>
        </div>

        <form *ngIf="!showPasswordResetProgressSpinner && !error.show && !success" class="example-form"
            [formGroup]="resetPasswordForm">
            <mat-card-content>
                <mat-form-field class="example-full-width">
                    <input [type]="hide ? 'password' : 'text'" matInput placeholder="{{ 'login.password' | translate }}"
                        [formControlName]="'password'">
                    <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                        <mat-icon>{{ hide ? "visibility_off" : "visibility"}}</mat-icon>
                    </button>
                </mat-form-field>
            </mat-card-content>
            <button mat-stroked-button color="primary" class="btn-block" (click)="resetPassword(resetPasswordForm)">
                <span>{{'buttons.reset_password'|translate}}</span>
            </button>
        </form>

        <div *ngIf="!showPasswordResetProgressSpinner && error.show" class="message">

            <p style="display: {{'es' | translate}};color: red;">El código de acción no es válido. Esto puede suceder si
                el código está mal formado, caducado o ya se ha utilizado.</p>
            <p style="display: {{'cat' | translate}};color: red;">El codi d'acció no és vàlid. Això pot passar si el
                codi està mal format, ha caducat o ja s'ha utilitzat.</p>
            <p style="display: {{'en' | translate}};color: red;">The action code is invalid. This can happen if the code
                is malformed, expired, or has already been used.</p>

        </div>

        <div *ngIf="success" class="message">
            <p style="display: {{'es' | translate}};color: green;">La contraseña se ha cambiado correctamente. Ya puede
                volver al inicio de sesión.</p>
            <p style="display: {{'cat' | translate}};color: green;">La contrasenya s'ha canviat correctament. Ja pot
                tornar a l'inici de sessió.</p>
            <p style="display: {{'en' | translate}};color: green;">The password has been changed successfully. You can
                now go back to the login.</p>
        </div>

        <button mat-flat-button class="backButton" [ngClass]="{'success': success}" routerLink="/login">
            <mat-icon>arrow_back</mat-icon>
            <span>&nbsp; {{'buttons.return' | translate}}</span>
        </button>
    </mat-card>

</div> -->